export enum SectionTypeEnum {
  PROCESSING = 'Em processamento',
  PAYMENT_PROCESSING = 'Pagamento pendente',
  AVAILABLE = 'Pra raspar',
  ACTIVE = 'Com sorteios ativos',
  COMPLETED = 'Finalizados',
}

export enum SectionTagTypeEnum {
  AVAILABLE = 'Disponível',
  ACTIVE = 'Ativo',
  COMPLETED = 'Finalizado',
}

export enum rafflesEnum {
  REALIZED = 'REALIZED',
  NEXT = 'NEXT',
  SOON = 'SOON',
  WIN = 'WIN',
}
